module.exports = __webpack_public_path__ + "static/media/lockIcon.2e769d9b.svg";